import type {
  AutocompleteData,
  ColorEffect,
  ColorStatus,
  Opacity,
} from "@color-finder/color-finder-api/models";

const COLOR_STATUS_VALUES: Partial<Record<ColorStatus, AutocompleteData>> = {
  ACTIVE: { name: "Active", value: "ACTIVE" },
  INACTIVE: { name: "Inactive", value: "INACTIVE" },
  UNKNOWN: { name: "Under Development", value: "UNKNOWN" },
};

export function getColorStatusValues(): Array<AutocompleteData> {
  return Object.values(COLOR_STATUS_VALUES);
}

export function getColorStatusValue(
  colorStatus: string,
): AutocompleteData | undefined {
  return COLOR_STATUS_VALUES[colorStatus as ColorStatus];
}

const OPACITY_VALUES: Record<Opacity, AutocompleteData> = {
  OPAQUE: { name: "Opaque", value: "OPAQUE" },
  TRANSPARENT: { name: "Transparent", value: "TRANSPARENT" },
  TRANSLUCENT: { name: "Translucent", value: "TRANSLUCENT" },
};

export function getOpacityValues(): Array<AutocompleteData> {
  return Object.values(OPACITY_VALUES);
}

export function getOpacityValue(opacity: string): AutocompleteData | undefined {
  return OPACITY_VALUES[opacity as Opacity];
}

const COLOR_EFFECT_VALUES: Record<ColorEffect, AutocompleteData> = {
  METALLIC_OR_PEARLESCENT: {
    name: "Metallic / Pearlescent",
    value: "METALLIC_OR_PEARLESCENT",
  },
  MARBLE: { name: "Marble", value: "MARBLE" },
  FLUORESCENT: { name: "Fluorescent", value: "FLUORESCENT" },
  PHOSPHORESCENT: { name: "Phosphorescent", value: "PHOSPHORESCENT" },
};

export function getColorEffectValues(): Array<AutocompleteData> {
  return Object.values(COLOR_EFFECT_VALUES);
}

export function getColorEffectValue(
  colorEffect: string,
): AutocompleteData | undefined {
  return COLOR_EFFECT_VALUES[colorEffect as ColorEffect];
}

const COLOR_GROUP_VALUES: Record<string, AutocompleteData & { color: string }> =
  {
    "0": { value: "0", name: "Black", color: "rgb(43,41,43)" },
    "1": { value: "1", name: "Gray", color: "rgb(147,142,147)" },
    "2": { value: "2", name: "White", color: "rgb(231,225,233)" },
    "10": { value: "10", name: "Red", color: "rgb(198,40,40)" },
    "11": { value: "11", name: "Yellow Red", color: "rgb(206,115,46)" },
    "12": { value: "12", name: "Yellow", color: "rgb(235,206,68)" },
    "13": { value: "13", name: "Green Yellow", color: "rgb(161,187,51)" },
    "14": { value: "14", name: "Green", color: "rgb(55,147,78)" },
    "15": { value: "15", name: "Blue Green", color: "rgb(33,167,158)" },
    "16": { value: "16", name: "Blue", color: "rgb(14,126,165)" },
    "17": { value: "17", name: "Purple Blue", color: "rgb(64,96,163)" },
    "18": { value: "18", name: "Purple", color: "rgb(86,22,112)" },
    "19": { value: "19", name: "Red Purple", color: "rgb(192,44,127)" },
  };

export function getColorGroupValues(): Array<
  AutocompleteData & { color: string }
> {
  return Object.values(COLOR_GROUP_VALUES);
}

export function getColorGroupValue(
  colorGroup: string,
): AutocompleteData | undefined {
  return COLOR_GROUP_VALUES[colorGroup];
}

export function getFakeAutocompleteValue(value: string): AutocompleteData {
  return { name: value, value: value };
}
